import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ChartModule, HIGHCHARTS_MODULES} from 'angular-highcharts';
import * as highcharts3d from 'highcharts/highcharts-3d';
import {TrendByCountryChartComponent} from './containers/country/pom/trend-by-country-chart/trend-by-country-chart.component';
import {TrendByCountryFiltersComponent} from './components/country/pom/trend-by-country-filters/trend-by-country-filters.component';
import {ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../shared/shared.module';
import {NgChartsModule} from 'ng2-charts';
import {RecycleChartComponent} from './containers/weeesystem/recycle-chart/recycle-chart.component';
import * as Highcharts from 'highcharts';
import HC_Exporting from 'highcharts/modules/exporting';
import HC_ExportData from 'highcharts/modules/export-data';
import {CountryVsWfChartComponent} from './containers/country/pom/country-vs-wf-chart/country-vs-wf-chart.component';
import {CountryVsWfFiltersComponent} from './components/country/pom/country-vs-wf-filters/country-vs-wf-filters.component';
import {CountryVsWfBarChartComponent} from './components/country/pom/country-vs-wf-bar-chart/country-vs-wf-bar-chart.component';
import {CompositionChartComponent} from './containers/country/pom/composition-chart/composition-chart.component';
import {CompositionPieChartComponent} from './components/country/pom/composition-pie-chart/composition-pie-chart.component';
import {CompositionFiltersComponent} from './components/country/pom/composition-filters/composition-filters.component';
import {EuropeanTrendChartComponent} from './containers/country/pom/european-trend-chart/european-trend-chart.component';
import {EuropeanTrendFiltersComponent} from './components/country/pom/european-trend-filters/european-trend-filters.component';
import {EuropeanTrendBarChartComponent} from './components/country/pom/european-trend-bar-chart/european-trend-bar-chart.component';
import {BenchmarkByYearFiltersComponent} from './components/country/pom/benchmark-by-year-filters/benchmark-by-year-filters.component';
import {BenchmarkByYearBarChartComponent} from './components/country/pom/benchmark-by-year-bar-chart/benchmark-by-year-bar-chart.component';
import {BenchmarkByYearChartComponent} from './containers/country/pom/benchmark-by-year-chart/benchmark-by-year-chart.component';
import {VctUpToComponent} from './containers/country/collected/vct-up-to/vct-up-to.component';
import {VctpUpToComponent} from './containers/country/collected/vctp-up-to/vctp-up-to.component';
import {VctpFromComponent} from './containers/country/collected/vctp-from/vctp-from.component';
import {VctFromComponent} from './containers/country/collected/vct-from/vct-from.component';
import {TrendByCountryComponent} from './containers/country/return/trend-by-country/trend-by-country.component';
import {ByYearChartComponent} from './containers/country/return/by-year-chart/by-year-chart.component';
import {ReturnTrendByCountryFilterComponent} from './components/country/return/trend-by-country-filter/return-trend-by-country-filter.component';
import {ByYearFilterComponent} from './components/country/return/by-year-filter/by-year-filter.component';
import {ByYearBarChartComponent} from './components/country/return/by-year-bar-chart/by-year-bar-chart.component';
import {ReturnTrendByCountryBarChartComponent} from './components/country/return/trend-by-country-bar-chart/return-trend-by-country-bar-chart.component';
import {TrendByCountryBarChartComponent} from './components/country/pom/trend-by-country-bar-chart/trend-by-country-bar-chart.component';
import {VctUpToFiltersComponent} from './components/country/collected/vct-up-to-filters/vct-up-to-filters.component';
import {VctUpToBarChartComponent} from './components/country/collected/vct-up-to-bar-chart/vct-up-to-bar-chart.component';
import {VctpUpToBarChartComponent} from './components/country/collected/vctp-up-to-bar-chart/vctp-up-to-bar-chart.component';
import {VctpUpToFiltersComponent} from './components/country/collected/vctp-up-to-filters/vctp-up-to-filters.component';
import {VctFromBarChartComponent} from './components/country/collected/vct-from-bar-chart/vct-from-bar-chart.component';
import {VctFromFilterComponent} from './components/country/collected/vct-from-filter/vct-from-filter.component';
import {VctpFromFilterComponent} from './components/country/collected/vctp-from-filter/vctp-from-filter.component';
import {VctpFromBarChartComponent} from './components/country/collected/vctp-from-bar-chart/vctp-from-bar-chart.component';
import {OperationsVsOverheadChartComponent} from './containers/weeesystem/cost/operations-vs-overhead-chart/operations-vs-overhead-chart.component';
import {OperationsVsOverheadPieChartComponent} from './components/weee-system/cost/operations-vs-overhead-pie-chart/operations-vs-overhead-pie-chart.component';
import {OperationsVsOverheadFiltersComponent} from './components/weee-system/cost/operations-vs-overhead-filters/operations-vs-overhead-filters.component';
import * as more from 'highcharts/highcharts-more.src';
import { ReturnRateBenchmarkComponent } from './containers/weeesystem/return-rate-benchmark/return-rate-benchmark.component';
import { ReturnRateBenchmarkByYearChartComponent } from './components/weee-system/return/return-rate-benchmark-by-year-chart/return-rate-benchmark-by-year-chart.component';
import { ReturnRateBenchmarkFiltersComponent } from './components/weee-system/return/return-rate-benchmark-filters/return-rate-benchmark-filters.component';
import { AdditionalChartComponent } from './containers/weeesystem/cost/additional-chart/additional-chart.component';
import { AdditionalFiltersComponent } from './components/weee-system/cost/additional-filters/additional-filters.component';
import { CostBenchmarkComponent } from './containers/weeesystem/cost/cost-benchmark/cost-benchmark.component';
import { CostBenchmarkChartComponent } from './components/weee-system/cost/cost-benchmark-chart/cost-benchmark-chart.component';
import { CostBenchmarkFiltersComponent } from './components/weee-system/cost/cost-benchmark-filters/cost-benchmark-filters.component';
import { RecycleBarChartComponent } from './components/weee-system/recycle/recycle-bar-chart/recycle-bar-chart.component';
import { RecycleChartFiltersComponent } from './components/weee-system/recycle/recycle-chart-filters/recycle-chart-filters.component';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import { DownloadKfDataComponent } from './components/download-kf-data/download-kf-data.component';
import { CostAdditionalBenchmarkChartComponent } from './components/weee-system/cost/cost-additional-benchmark-chart/cost-additional-benchmark-chart.component';

HC_Exporting(Highcharts);
HC_ExportData(Highcharts);
Highcharts.setOptions({
  plotOptions: {
    column: {
      depth: 50,
      grouping: true,
      maxPointWidth: 100,
    },
    pie: {
      depth: 35,
      cursor: 'pointer',
    },
    columnrange: {
      maxPointWidth: 8,
      allowPointSelect: true,
      minPointLength: 5,
    },
  },
  exporting: {
    buttons: {
      contextButton: {
        menuItems:  ['viewFullscreen', 'printChart', 'separator', 'downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG',
          'downloadCSV', 'viewData'],
      }
    },
    menuItemDefinitions: {
      downloadCSV: {
        text: 'Download data'
      }
    }
  },
  yAxis: {
    title: {
      text: null
    }
  },
  credits: {
    text: '© WEEE Forum Key Figures | Highcharts.com'
  }
});

// @ts-ignore
@NgModule({
  declarations: [
    TrendByCountryChartComponent,
    TrendByCountryFiltersComponent,
    TrendByCountryBarChartComponent,
    CountryVsWfChartComponent,
    CountryVsWfFiltersComponent,
    CountryVsWfBarChartComponent,
    CompositionChartComponent,
    CompositionPieChartComponent,
    CompositionFiltersComponent,
    EuropeanTrendChartComponent,
    EuropeanTrendFiltersComponent,
    EuropeanTrendBarChartComponent,
    BenchmarkByYearFiltersComponent,
    BenchmarkByYearBarChartComponent,
    BenchmarkByYearChartComponent,
    RecycleChartComponent,
    RecycleBarChartComponent,
    RecycleChartFiltersComponent,
    BenchmarkByYearChartComponent,
    VctUpToComponent,
    VctpUpToComponent,
    VctpFromComponent,
    VctFromComponent,
    TrendByCountryComponent,
    ByYearChartComponent,
    ReturnTrendByCountryFilterComponent,
    ByYearFilterComponent,
    ByYearBarChartComponent,
    ReturnTrendByCountryBarChartComponent,
    TrendByCountryBarChartComponent,
    CostBenchmarkComponent,
    CostBenchmarkChartComponent,
    CostBenchmarkFiltersComponent,
    TrendByCountryBarChartComponent,
    VctUpToFiltersComponent,
    VctUpToBarChartComponent,
    VctpUpToBarChartComponent,
    VctpUpToFiltersComponent,
    VctFromBarChartComponent,
    VctFromFilterComponent,
    VctFromFilterComponent,
    VctpFromFilterComponent,
    VctpFromBarChartComponent,
    OperationsVsOverheadChartComponent,
    OperationsVsOverheadPieChartComponent,
    OperationsVsOverheadFiltersComponent,
    ReturnRateBenchmarkComponent,
    ReturnRateBenchmarkByYearChartComponent,
    ReturnRateBenchmarkFiltersComponent,
    OperationsVsOverheadFiltersComponent,
    AdditionalChartComponent,
    AdditionalFiltersComponent,
    DownloadKfDataComponent,
    CostAdditionalBenchmarkChartComponent,
  ],
  imports: [
    CommonModule,
    ChartModule,
    ReactiveFormsModule,
    SharedModule,
    NgChartsModule
  ],
  providers: [
    { provide: HIGHCHARTS_MODULES, useFactory: () => [ highcharts3d, more, NoDataToDisplay] } // add as factory to your providers
  ]
})
export class KfChartsModule { }
